import enData from './en.json'
import svData from './translations/sv.json'

export const localeData = {
  en: { ...enData },
  sv: { ...enData, ...svData },
}
